<template>
  <div>
    <span class="rating">
      <el-rate
        v-model="rateNum"
        :icon-classes="iconClasses"
        void-icon-class="app-rate-icon-off"
        :disabled="disabled"
        @change="num => this.$emit('change', num)"
      />
    </span>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    number: Number,
    disabled: Boolean,
  },
  data() {
    return {
      iconClasses: new Array(3).fill('app-rate-icon'),
      rateNum: this.number || 0,
    }
  },
  watch: {
    number(val) {
      this.rateNum = val
    },
  },
}
</script>

<style lang="less">
/* 全局样式 */
.el-rate__icon {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  color: #99d20d !important;
  &::before {
    content: '\E69F';
  }
}
.el-rate__icon.app-rate-icon {
  &::before {
    content: '\E69D';
  }
}
</style>

<style lang="less" scoped>
.rating {
  display: inline-block;
  vertical-align: middle;
  min-width: 110px;
}
</style>
